import { __spreadArrays } from "tslib";
import ddt from '@wix/da-ddt';
import pick from 'lodash/pick';
import getFieldsForEvent from './eventRegistry';
import { BiEventType } from './constants';
var logger = ddt.createLogger('bilogger');
export function validateEvent(event) {
    var eventFields = Object.keys(event);
    var eventId = event['evid'];
    // Test event is literally whatever
    if (eventId === BiEventType.TEST) {
        return event;
    }
    if (!eventId) {
        logger.error('Event is missing evid', event);
        return event;
    }
    var registry = getFieldsForEvent(eventId);
    if (!registry) {
        logger.error('Event missing from registry - remember to add it!!', event);
        return event;
    }
    var missingRequired = registry.requiredFields.filter(function (field) { return !eventFields.includes(field); });
    if (missingRequired.length) {
        logger.warn('Event missing required fields', { event: event, missingRequired: missingRequired });
    }
    var allKnownFields = __spreadArrays(registry.requiredFields, registry.optionalFields);
    var unknownFields = eventFields.filter(function (field) { return !allKnownFields.includes(field); });
    if (unknownFields.length) {
        logger.warn("Event (evid=" + eventId + ") has unknown fields: " + unknownFields, { event: event, unknownFields: unknownFields });
        return pick(event, allKnownFields);
    }
    return event;
}
//# sourceMappingURL=eventValidator.js.map